import { useReactiveVar } from '@apollo/client/react';
import { aiThreadIdVar } from 'src/editor/toolbars/right-panel/ai/ai-thread-id';

/**
 * The singleton AI chat thread id.
 * Kept in a leaf module so the chat editor's MentionElement can use it
 * without importing the chat page and creating an import cycle through the chat barrels.
 */
export function useThreadId() {
  const threadId = useReactiveVar(aiThreadIdVar);
  return { threadId };
}
